import { IconAccordionArrow } from './IconAccordionArrow'

export default IconAccordionArrow
